module.exports = __webpack_public_path__ + "static/media/background-1.085a419e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/landing_images/background-1.jpeg
// module id = 1153
// module chunks = 0